export default __webpack_public_path__ + "static/media/Dickschnabelpinguin.6e8ddb63.jpg";